import React from "react"
import FieldProto from "../field-proto";
import {FieldViewSize} from "../../const";
import {FieldRenderOptions} from "../types";

export type FieldEditableProps = {
    className?      : string
    style?          : style

    textClassName?  : string

    size?           : FieldViewSize,
    field           : FieldProto
    model           : any

    iconOnly?       : boolean
    isEditable?     : boolean

    options?        : FieldRenderOptions
    disabled?       : boolean
    onChange?       : onChangeCallback

    onAddClick? : callback

    onFocus?        : callback      // this one is used in table to prevent dnd when input in focus i.e. we want to copy current value
    onBlur?         : callback      // this one is used in table to prevent dnd when input in focus i.e. we want to copy current value
}

export type FieldEditableState = {
    mode   : FieldEditableMode
}

export enum FieldEditableMode {
    VIEW            = 1,
    HOVERED_VIEW    = 2,
    HOVERED         = 3,
    EDITING         = 4,
}

export default function FieldProto_Editable(props: FieldEditableProps) {

    // const value = props.model[props.field.fieldId]
    const value = props.field.getViewValue(props.model)

    return <div className="ui5-txt-default ui5-txt-red">{props.field.type}.editable</div>

}
